import {
  BuscaCidadaoListagemDesenvolvimentoInfantilQuery,
  BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables,
  BuscaCidadaoListagemDiabetesQuery,
  BuscaCidadaoListagemDiabetesQueryVariables,
  BuscaCidadaoListagemGeralQuery,
  BuscaCidadaoListagemGeralQueryVariables,
  BuscaCidadaoListagemGestantePuerperaQuery,
  BuscaCidadaoListagemGestantePuerperaQueryVariables,
  BuscaCidadaoListagemHipertensaoQuery,
  BuscaCidadaoListagemHipertensaoQueryVariables,
  BuscaCidadaoListagemPessoaIdosaQuery,
  BuscaCidadaoListagemPessoaIdosaQueryVariables,
  BuscaCidadaoListagemSaudeBucalQuery,
  BuscaCidadaoListagemSaudeBucalQueryVariables,
  BuscaCidadaoListagemTematicaSaudeMulherQuery,
  BuscaCidadaoListagemTematicaSaudeMulherQueryVariables,
  GrupoImunobiologicoEnum,
} from 'graphql/types.generated'

type CidadaoListagemDiabetesQueryResult = BuscaCidadaoListagemDiabetesQuery['acompanhamentoCondicaoSaude']
type CidadaoListagemPessoaIdosaQueryResult = BuscaCidadaoListagemPessoaIdosaQuery['acompanhamentoCondicaoSaude']
type CidadaoListagemHipertensaoQueryResult = BuscaCidadaoListagemHipertensaoQuery['acompanhamentoCondicaoSaude']
type CidadaoListagemSaudeBucalQueryResult = BuscaCidadaoListagemSaudeBucalQuery['acompanhamentoCondicaoSaude']

export type CidadaoListagemDiabetesQueryModel = CidadaoListagemDiabetesQueryResult['content'][0]
export type CidadaoListagemPessoaIdosaQueryModel = CidadaoListagemPessoaIdosaQueryResult['content'][0]
export type CidadaoListagemHipertensaoQueryModel = CidadaoListagemHipertensaoQueryResult['content'][0]
export type CidadaoListagemSaudeBucalQueryModel = CidadaoListagemSaudeBucalQueryResult['content'][0]

export type BuscaCidadaoQuery =
  | BuscaCidadaoListagemGeralQuery
  | BuscaCidadaoListagemGestantePuerperaQuery
  | BuscaCidadaoListagemHipertensaoQuery
  | BuscaCidadaoListagemDiabetesQuery
  | BuscaCidadaoListagemPessoaIdosaQuery
  | BuscaCidadaoListagemDesenvolvimentoInfantilQuery
  | BuscaCidadaoListagemSaudeBucalQuery
  | BuscaCidadaoListagemTematicaSaudeMulherQuery

export type BuscaCidadaoQueryResult = BuscaCidadaoQuery['acompanhamentoCondicaoSaude']
export type BuscaCidadaoQueryResultModel = BuscaCidadaoQueryResult['content'][0]

export type BuscaCidadaoQueryVariables =
  | BuscaCidadaoListagemGestantePuerperaQueryVariables
  | BuscaCidadaoListagemGeralQueryVariables
  | BuscaCidadaoListagemHipertensaoQueryVariables
  | BuscaCidadaoListagemDiabetesQueryVariables
  | BuscaCidadaoListagemPessoaIdosaQueryVariables
  | BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables
  | BuscaCidadaoListagemSaudeBucalQueryVariables
  | BuscaCidadaoListagemTematicaSaudeMulherQueryVariables

export const grupoImunobiologicoLabel: Record<GrupoImunobiologicoEnum, string> = {
  DIFTERIA_TETANO_PERTUSIS_HEPATITE_B_HAEMOPHILUS_INFLUENZA_B:
    'Difteria, Tétano, Pertusis, Hepatite B, Haemophilus Influenza B',
  POLIOMELITE: 'Poliomielite',
  SARAMPO_CACHUMBA_RUBEOLA: 'Sarampo, Caxumba, Rubéola',
  PNEUMOCOCICA: 'Pneumocócica',
  DTPA: 'dTpa',
  INFLUENZA: 'Influenza (últimos 12 meses)',
  HPV: 'HPV',
}
